import { ColorsSection } from "./colors-section";
import { ControlsSection } from "./controls-section";
import { DataDisplaySection } from "./data-display-section";
import { LayoutSection } from "./layout-section";
import { TypographySection } from "./typography-section";

export function DesignSystemPage() {
	return (
		<div className="flex flex-1 flex-col gap-10 p-4 lg:p-6 max-w-5xl">
			<div>
				<h1 className="text-2xl font-bold">Design System</h1>
				<p className="text-muted-foreground mt-1">
					Paleta kolorów, typografia i komponenty używane w aplikacji.
				</p>
			</div>

			<ColorsSection />
			<TypographySection />
			<ControlsSection />
			<DataDisplaySection />
			<LayoutSection />
		</div>
	);
}
